<template>
  <div class="tiptap-vuetify-image-upload-area">
    <input
      id="tiptap-vuetify-image-upload-area__input-file"
      type="file"
      accept="image/*"
      multiple
    >

    <label
      class="tiptap-vuetify-image-upload-area-holder"
      for="tiptap-vuetify-image-upload-area__input-file"
    >
      <div>
        <svg
          class="tiptap-vuetify-image-upload-area-holder__icon"
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="43"
          viewBox="0 0 50 43"
        >
          <path
            d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
          />
        </svg>
        <br><br>
      </div>
    </label>
  </div>
</template>

<script>
/**
 * @component WorkTextEditorImageUploadArea
 * @description Image upload area for `WorkTextEditor`. Supports file selection via click
 * and drag-and-drop. Converts images to Base64 strings and emits them via event.
 *
 * @emits {{ src: String, alt: String }} select-file - Emitted when an image
 *   is selected or dropped. Passes `{ src: base64String, alt: filename }`.
 */
export default {
  name: 'WorkTextEditorImageUploadArea',
  data() {
    return {
      readers: []
    }
  },
  mounted() {
    const input = this.getInputElement();
    input?.addEventListener('change', this.handleInputChange);

    const holder = this.getHolderElement();
    holder?.addEventListener('dragover', this.handleDragOver);
    holder?.addEventListener('dragleave', this.dragleaveOrEndHandler)
    holder?.addEventListener('dragend', this.dragleaveOrEndHandler)
    holder?.addEventListener('drop', this.handleDrop);
  },
  beforeDestroy() {
    this.cleanup();
  },
  deactivated() {
    this.cleanup();
  },
  methods: {
    handleReaderLoad(readerEvent, file) {
      this.$emit('select-file', {
        src: readerEvent.target.result.toString(),
        alt: file.name
      })
    },
    filesSelected(files) {
      [...files].forEach(file => {
        const reader = new FileReader();
        reader.addEventListener('load', (readerEvent) => this.handleReaderLoad(readerEvent, file));
        reader.readAsDataURL(file);
        this.readers.push(reader);
      })
    },
    getInputElement() {
      return this.$el.querySelector('#tiptap-vuetify-image-upload-area__input-file');
    },
    getHolderElement() {
      return this.$el.querySelector('.tiptap-vuetify-image-upload-area-holder');
    },
    handleInputChange(e) {
      if (e.target instanceof HTMLInputElement) {
        this.filesSelected(e.target.files);
        this.getHolderElement()
          ?.classList
          ?.remove('tiptap-vuetify-image-upload-area-holder--dragover');

        e.target.value = ''
      }
    },
    handleDragOver(e) {
      e.preventDefault()
      this.getHolderElement()
        ?.classList
        ?.add('tiptap-vuetify-image-upload-area-holder--dragover');
    },
    handleDrop(e) {
      e.preventDefault()
      this.filesSelected(e.dataTransfer.files)
    },
    dragleaveOrEndHandler() {
      this.getHolderElement()
        ?.classList
        ?.remove('tiptap-vuetify-image-upload-area-holder--dragover');
      return false;
    },
    cleanup() {
      const input = this.getInputElement();
      input?.removeEventListener('change', this.handleInputChange);

      const holder = this.getHolderElement();
      holder?.removeEventListener('dragover', this.handleDragOver);
      holder?.removeEventListener('dragleave', this.dragleaveOrEndHandler);
      holder?.removeEventListener('dragend', this.dragleaveOrEndHandler);
      holder?.removeEventListener('drop', this.handleDrop);

      for (const reader of this.readers) {
        reader?.removeEventListener('load', this.handleReaderLoad);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.tiptap-vuetify-image-upload-area-holder {
  height: 6rem !important;

  .tiptap-vuetify-image-upload-area-holder__icon {
    height: 3rem !important;
    margin-top: 3rem !important;
    margin-bottom: 0px !important;
  }
}
</style>